export default "__VITE_ASSET__ddTSbXwp__"